import React, { SVGProps } from 'react'
const SvgCloseLoD = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FFF"
      d="m27.122 25 7.424 7.425a1.5 1.5 0 0 1-2.121 2.121L25 27.121l-7.424 7.425a1.5 1.5 0 0 1-2.122-2.121L22.88 25l-7.425-7.424a1.5 1.5 0 0 1 2.122-2.122L25 22.88l7.425-7.425a1.5 1.5 0 0 1 2.121 2.122L27.122 25Z"
    />
  </svg>
)
export default SvgCloseLoD
